import actions from "@/store/actions/handsAction.ts";
import mutations from "@/store/mutations/handsMutation";
import getters from "@/store/getters/handsGetter";
export default {
  state: {
    palm_print_data: [],
    face_reading_data: [],
    reading_data_list: []
  },
  actions: actions,
  mutations: mutations,
  getters: getters
};